import { render } from "./Side.vue?vue&type=template&id=bb62e3a4"
import script from "./Side.vue?vue&type=script&lang=js"
export * from "./Side.vue?vue&type=script&lang=js"

import "./Side.vue?vue&type=style&index=0&id=bb62e3a4&lang=css"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__